import { api } from './base';

import { Nullable, Pageable } from 'v2/types';
import { SWRKeyPaginationWithExtra, SWRKeyValue } from 'v2/types/swr';
import {
  FavoriteSlotDto,
  TournamentBalanceDto,
  TournamentHistoryDto,
  UserActiveTicketsDto,
  UserFingerprintDto,
  UserIdentifierDto,
  UserStatisticDto,
  UserWinRewardDto,
} from 'v2/types/UserProfileModel';
import { normalizeSearch } from 'v2/utils';

interface ByIpParams {
  ip: string;
  excludeUserId: string;
}

interface ByFingerprintParams {
  fingerprintId: string;
  excludeUserId: string;
}

interface UserWinRewardsParams {
  userId: string;
  value?: string;
}

export const userProfileService = {
  getUserStatistic([_key, userId]: SWRKeyValue): Promise<UserStatisticDto> {
    return api.get(`v1/admin/user-statistic/by-user/${userId}`).json();
  },

  getUserFingerprints([_key, userId]: SWRKeyValue): Promise<UserFingerprintDto[]> {
    return api.get(`v1/admin/user-metrics/by-user/${userId}`).json();
  },

  getUserFavoriteSlots([_key, userId]: SWRKeyValue): Promise<FavoriteSlotDto[]> {
    return api.get(`v1/admin/provider-slot/by-user/${userId}/favorites`).json();
  },

  getUsersByIp([_key, page, limit, params]: SWRKeyPaginationWithExtra<ByIpParams>): Promise<
    Pageable<UserIdentifierDto>
  > {
    return api
      .get('v1/admin/user/by-ip', {
        searchParams: normalizeSearch({
          ip: params.ip,
          excludeUserId: params.excludeUserId,
          page,
          limit,
        }),
      })
      .json();
  },

  getUsersByFingerprint([_key, page, limit, params]: SWRKeyPaginationWithExtra<ByFingerprintParams>): Promise<
    Pageable<UserIdentifierDto>
  > {
    return api
      .get('v1/admin/user/by-fingerprint', {
        searchParams: normalizeSearch({
          fingerprintId: params.fingerprintId,
          excludeUserId: params.excludeUserId,
          page,
          limit,
        }),
      })
      .json();
  },

  getUserTournamentActiveBalance([_key, userId]: SWRKeyValue): Promise<Nullable<TournamentBalanceDto>> {
    return api.get(`admin/tournament/user/${userId}/active-balance`).json();
  },

  getUserTournamentHistory([_key, page, limit, userId]: SWRKeyPaginationWithExtra<string>): Promise<
    Pageable<TournamentHistoryDto>
  > {
    return api
      .get(`admin/tournament/user/${userId}/history`, {
        searchParams: { page, limit },
      })
      .json();
  },

  getUserWinRewards([_key, page, limit, params]: SWRKeyPaginationWithExtra<UserWinRewardsParams>): Promise<
    Pageable<UserWinRewardDto>
  > {
    const filter = params.value ? JSON.stringify({ value: params.value }) : undefined;
    return api
      .get(`admin/user-win-reward/by-user/${params.userId}`, {
        searchParams: normalizeSearch({ page, limit, filter }),
      })
      .json();
  },

  getUserActiveTickets([_key, userId]: SWRKeyValue): Promise<UserActiveTicketsDto> {
    return api.get(`v1/admin/ticket/user/${userId}/active`).json();
  },
};
